import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { evictFields } from "../../../helpers/cache";
import { UPDATE_CUSTOMER } from "../customer.queries";
import {
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables,
} from "../../../__generated__/UpdateCustomerMutation";

/**
 * Met à jour uniquement la note d'un client, pour l'édition en place depuis
 * sa fiche — sans passer par le formulaire complet de `useUpdateCustomer`.
 */
export const useUpdateCustomerNote = () => {
  const [mutate, { loading }] = useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UPDATE_CUSTOMER, {
    refetchQueries: ["CustomersQuery", "CustomerQuery"],
    update(cache) {
      evictFields(cache, ["customer", "customers"]);
    },
  });

  const updateNote = async (id: number, note: string): Promise<boolean> => {
    if (loading) return false;
    try {
      const { data } = await mutate({ variables: { id, input: { note } } });
      if (data?.updateCustomer?.ok) {
        toast.success("La note a été enregistrée");
        return true;
      }
      toast.error(data?.updateCustomer?.error ?? "Une erreur est survenue");
      return false;
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
      return false;
    }
  };

  return { updateNote, loading };
};
